if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.currentIndex = 0;
        this.mediaItems = [];

        this.prevButton = this.querySelector('.product-media-modal__nav--prev');
        this.nextButton = this.querySelector('.product-media-modal__nav--next');
        this.counterCurrent = this.querySelector('.product-media-modal__counter-current');
        this.counterTotal = this.querySelector('.product-media-modal__counter-total');

        if (this.prevButton) {
          this.prevButton.addEventListener('click', this.showPrevious.bind(this));
          this.prevButton.addEventListener('pointerup', (event) => event.stopPropagation());
        }
        if (this.nextButton) {
          this.nextButton.addEventListener('click', this.showNext.bind(this));
          this.nextButton.addEventListener('pointerup', (event) => event.stopPropagation());
        }

        this.addEventListener('keydown', this.onKeyDown.bind(this));

        this.contentContainer = this.querySelector('[role="document"]');
        if (this.contentContainer) {
          this.contentContainer.addEventListener('touchstart', this.onTouchStart.bind(this), { passive: true });
          this.contentContainer.addEventListener('touchend', this.onTouchEnd.bind(this), { passive: true });
        }
        this.touchStartX = 0;
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.mediaItems = Array.from(this.querySelectorAll('[data-media-id]'));
        if (this.counterTotal) this.counterTotal.textContent = this.mediaItems.length;
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        activeMedia.classList.add('active');

        this.currentIndex = this.mediaItems.indexOf(activeMedia);
        this.updateCounter();

        this.loadActiveMediaContent(activeMedia);
      }

      loadActiveMediaContent(activeMedia) {
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      setActiveByIndex(index) {
        if (!this.mediaItems.length) return;
        const total = this.mediaItems.length;
        this.currentIndex = (index + total) % total;

        window.pauseAllMedia();

        this.mediaItems.forEach((item) => item.classList.remove('active'));
        const activeMedia = this.mediaItems[this.currentIndex];
        activeMedia.classList.add('active');

        this.loadActiveMediaContent(activeMedia);
        this.updateCounter();
      }

      showNext() {
        this.setActiveByIndex(this.currentIndex + 1);
      }

      showPrevious() {
        this.setActiveByIndex(this.currentIndex - 1);
      }

      updateCounter() {
        if (this.counterCurrent) this.counterCurrent.textContent = this.currentIndex + 1;
      }

      onKeyDown(event) {
        if (event.code === 'ArrowRight') {
          event.preventDefault();
          this.showNext();
        } else if (event.code === 'ArrowLeft') {
          event.preventDefault();
          this.showPrevious();
        }
      }

      onTouchStart(event) {
        this.touchStartX = event.changedTouches[0].screenX;
      }

      onTouchEnd(event) {
        const touchEndX = event.changedTouches[0].screenX;
        const delta = touchEndX - this.touchStartX;
        const threshold = 40;
        if (delta > threshold) {
          this.showPrevious();
        } else if (delta < -threshold) {
          this.showNext();
        }
      }
    }
  );
}
